import { useThemeObserver } from '@atlaskit/tokens';
/**
 * Warning -- if additional color modes beyond light and dark are added in future -- this will have unexpected behaviour
 */
export var useIconThemed = function useIconThemed() {
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  return {
    iconThemed: function iconThemed(colors) {
      return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
    }
  };
};